/* unplugin-vue-components disabled */import { render } from "./notice.vue?vue&type=template&id=3f4f133e&scoped=true&ts=true"
import script from "./notice.vue?vue&type=script&lang=ts"
export * from "./notice.vue?vue&type=script&lang=ts"

import "./notice.vue?vue&type=style&index=0&id=3f4f133e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\17532\\Desktop\\school\\logistics-meet\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f4f133e"]])

export default __exports__